import React, { useCallback, useEffect, useState } from "react"
import { changeUserProfile } from "../../store/slices/MSALSlice"
import { getUserImage } from "../../services/ApiServices"
import { useDispatch, useSelector } from "react-redux"
import { useMsal } from "@azure/msal-react"
import "./Header.css"

import userThumb from "../../assets/img/user_thumb.jpg"

export default function Header() {
    const currentUser = useSelector((state) => state.APIResponse.CurrentUser)
    const userName = useSelector((state) => state.MSALAuth.userName)
    const userEmail = useSelector((state) => state.MSALAuth.userEmail)
    const userProfile = useSelector((state) => state.MSALAuth.userProfile)

    const { instance } = useMsal()
    const dispatch = useDispatch()

    const handleLogout = useCallback(() => {
        instance.logoutRedirect({ postLogoutRedirectUri: "/" })
    }, [instance])

    useEffect(() => {
        getUserImage(userEmail).then((response) => {
            if (typeof response === "object" && !response?.ExceptionMessage && !response?.Message) {
                dispatch(changeUserProfile(response?.Image ?? ""))
            } else {
                console.error(response)
            }
        }).catch((error) => {
            console.error(error)
        })
    }, [dispatch, userEmail])

    return (
        <header className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center">
                    {currentUser?.AppLogo?.Image && (
                        <img src={currentUser?.AppLogo?.Image} alt="MyDesk-Logo" />
                    )}
                </a>
            </div>
            <nav className="header-nav ms-auto dropdown">
                <ul className="d-flex align-items-center dropdown-toggle" data-bs-toggle="dropdown">
                    <li className="nav-item dropdown">
                        <div className="nav-link nav-profile d-flex align-items-center pe-0">
                            <span className="d-none d-md-block pe-2">Hi, <span>{userName}</span> </span>
                            <img src={userProfile ? userProfile : userThumb} alt="Profile" className="rounded-circle" />
                        </div>
                    </li>
                </ul>

                <ul className="dropdown-menu dropdown-menu-arrow position-absolute profile overflow-hidden">
                    <li className="dropdown-header">
                        <h6>{userName}</h6>
                        <span>{userEmail}</span>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                        <div onClick={() => handleLogout()} className="admin-drop-down dropdown-item d-flex align-items-center">
                            <i className="fa-solid fa-arrow-right-from-bracket" />
                            <span>Sign Out</span>
                        </div>
                    </li>
                </ul>
            </nav>
        </header>
    )
}
